import React from "react";
import { Outlet } from "react-router-dom";
import { useLoginSession } from "shared/LoginSession";
import MainHud from "shared/components/MainHud";

const FHCHud = () => {
    const { userInfo } = useLoginSession(false);
    const surveyAdmin = userInfo?.permissions?.includes("FHC_MANAGE_SURVEYS");
    const profileManager = userInfo?.permissions?.includes("FHC_MANAGE_PROFILE");
    const resultsViewer = userInfo?.permissions?.includes("FHC_VIEW_SURVEY_RESULTS");

    const links = (
        userInfo?.superuser
            ? [{ label: "Configuration", path: "/admin/configuration" }]
            : [
                  profileManager && { label: "Profile", path: "/profile" },
                  // { label: "Dashboard", path: "/dashboard" }, // todo: DISABLED : until we have something functional
                  surveyAdmin && { label: "Questions", path: "/questions" },
                  surveyAdmin && { label: "Branding", path: "/branding" },
                  resultsViewer && { label: "Responses", path: "/responses" },
              ]
    ).filter(Boolean); // Removes any false/null values

    return (
        <MainHud headerLinks={links} overlayDrawer transparentDrawer={false}>
            {Outlet}
        </MainHud>
    );
};

export default FHCHud;
